/**
 * The top bar's backing (#250, #249). Clear at the top of the landing page, so the hero's glow shows through it; the
 * solid canvas at the top of every other page; frosted glass once any page has scrolled, so the content running
 * under the sticky bar never collides with the tabs (the landing's hero used to scroll straight through them).
 */
export type NavSurface = "clear" | "solid" | "glass";

export function navSurface({ pathname, scrollY }: { readonly pathname: string; readonly scrollY: number }): NavSurface {
  if (scrollY > 0) return "glass";
  return pathname === "/" ? "clear" : "solid";
}
